import React from 'react';
import { createRoot } from 'react-dom/client';

import { AnnonceAside } from '../main-app/components/AnnonceAside/AnnonceAside';
import { AnnonceCategory } from '../main-app/enums';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.querySelector('#react-annonce-aside') as HTMLElement | null;

  if (node !== null) {
    const {
      annonceId, category, title,
    } = node.dataset;

    const root = createRoot(node);
    root.render(<AnnonceAside annonceId={annonceId} category={category as AnnonceCategory} title={title} />);
  }
});
